// eslint-disable-next-line import/no-default-export
export default {
  upgrade: (workspace: string): string =>
    `/${workspace}/workspace/settings/plans`,
  learnMoreAboutPremium: 'https://www.atlassian.com/software/bitbucket/premium',
};
